function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 17,
  fill: "white",
  stroke: "#EF2727"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1668_36008)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0875 17.1876L13.55 19.6501C13.6421 19.7359 13.716 19.8394 13.7672 19.9544C13.8185 20.0694 13.846 20.1935 13.8482 20.3194C13.8505 20.4453 13.8273 20.5703 13.7802 20.687C13.733 20.8038 13.6628 20.9098 13.5738 20.9988C13.4848 21.0879 13.3787 21.1581 13.262 21.2052C13.1453 21.2524 13.0202 21.2755 12.8943 21.2733C12.7685 21.2711 12.6443 21.2435 12.5293 21.1923C12.4143 21.141 12.3108 21.0672 12.225 20.9751L8.1625 16.9126L7.5 16.2501L8.1625 15.5876L12.225 11.5251C12.4027 11.3595 12.6378 11.2693 12.8807 11.2736C13.1235 11.2779 13.3553 11.3763 13.527 11.548C13.6988 11.7198 13.7972 11.9515 13.8015 12.1944C13.8058 12.4373 13.7156 12.6723 13.55 12.8501L11.0875 15.3126H23.4375C24.5149 15.3126 25.5483 15.7406 26.3101 16.5024C27.072 17.2643 27.5 18.2976 27.5 19.3751C27.5 20.4525 27.072 21.4858 26.3101 22.2477C25.5483 23.0095 24.5149 23.4376 23.4375 23.4376H20.9375C20.6889 23.4376 20.4504 23.3388 20.2746 23.163C20.0988 22.9871 20 22.7487 20 22.5001C20 22.2514 20.0988 22.013 20.2746 21.8371C20.4504 21.6613 20.6889 21.5626 20.9375 21.5626H23.4375C24.0177 21.5626 24.5741 21.3321 24.9843 20.9218C25.3945 20.5116 25.625 19.9552 25.625 19.3751C25.625 18.7949 25.3945 18.2385 24.9843 17.8283C24.5741 17.418 24.0177 17.1876 23.4375 17.1876H11.0875Z",
  fill: "#EF2727"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1668_36008"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(7.5 7.5)"
})));
function SvgGoBackRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackRed);
export default __webpack_public_path__ + "static/media/Go_Back_Red.4a49abeb013bdb1da4d82a883058c1b3.svg";
export { ForwardRef as ReactComponent };